export function caseInsensitiveStartsWith(inputString, targetString) {
    return inputString.toLowerCase().startsWith(targetString.toLowerCase());
}